<div [formGroup]="form" *ngIf="navData" class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutAlign="start start" fxLayoutGap="5px">
        <mat-icon>tune</mat-icon>
        <div i18n *ngIf="!navData?.data">Create a new field</div>
        <div i18n *ngIf="navData?.data">Edit custom field</div>
    </div>
    <div class="body" fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start center">
        <ng-container *ngIf="customer$ | async as customer">
            <div
                *ngIf="customer.predefined_custom_fields?.length > 0"
                fxLayoutGap="4px"
                fxLayout="column"
                class="w-100 input-field-parent select"
            >
                <span i18n>Predefined fields</span>
                <mat-form-field class="role-field">
                    <mat-select [disabled]="navData?.data" fxFlex="1 1 100%" [formControl]="predefinedFieldIdControl">
                        <mat-option class="scope-option" [value]="null"> None </mat-option>
                        <mat-option
                            class="scope-option"
                            *ngFor="let field of customer.predefined_custom_fields"
                            [value]="field"
                        >
                            {{ field.name[localeId] }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </ng-container>
        <div fxLayout="column" fxLayoutGap="4px" class="w-100">
            <span class="label-name" i18n="@@name">Name*</span>
            <app-title-translation
                type="title"
                [borderedStyle]="true"
                i18n-placeholder
                placeholder="Enter Field name"
                formControlName="name"
            ></app-title-translation>
        </div>
        <div
            *ngIf="
                form.value.type != FieldType.SINGLE_CHOICE &&
                form.value.type != FieldType.MULTIPLE_CHOICE &&
                form.value.type != FieldType.SWITCH
            "
            fxLayout="column"
            fxLayoutGap="4px"
            class="w-100"
        >
            <span class="label-name" i18n="@@placeholder">Placeholder</span>
            <app-title-translation
                type="title"
                [borderedStyle]="true"
                i18n-placeholder
                placeholder="Enter Field placeholder"
                formControlName="placeholder"
            ></app-title-translation>
        </div>
        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent select">
            <span i18n>Specified for</span>
            <mat-form-field class="role-field">
                <mat-select
                    [disabled]="!!navData?.data || !!form.value.key"
                    fxFlex="1 1 100%"
                    formControlName="scope_id"
                >
                    <mat-option class="scope-option" *ngFor="let scope of scopes" [value]="scope.value">
                        <mat-icon
                            class="main-icon-option"
                            *ngIf="scope.isMainResource"
                            matListIcon
                            fontSet="klickdata"
                            [fontIcon]="scope.icon"
                        ></mat-icon>
                        <mat-icon class="normal-icon-option" *ngIf="!scope.isMainResource">{{ scope.icon }}</mat-icon>
                        {{ scope.title | async }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <app-user-setting-input
            *ngIf="navData.data?.hasOrder"
            [numbersCounterChanger]="true"
            type="number"
            i18n-placeholder
            placeholder="Enter Field order"
            [control]="form.get('order') | cast"
        >
            <label role="input-label" i18n="@@order">Order</label>
        </app-user-setting-input>
        <app-user-setting-input class="active-switch" type="switch" [control]="form.get('disabled') | cast">
            <span class="label" role="switch-label">
                <ng-container i18n="active">Active</ng-container>
            </span>
        </app-user-setting-input>
        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent select">
            <span i18n>Field type*</span>
            <mat-form-field class="role-field">
                <mat-select [disabled]="!!navData?.data || !!form.value.key" fxFlex="1 1 100%" formControlName="type">
                    <mat-select-trigger>
                        <mat-icon>{{ (form.value.type | formBuilderItemPipe)?.icon }}</mat-icon
                        >&nbsp;{{ (form.value.type | formBuilderItemPipe)?.label }}
                    </mat-select-trigger>

                    <mat-option *ngFor="let type of formBuilderItemTypes" [value]="type">
                        <mat-icon>{{ (type | formBuilderItemPipe).icon }}</mat-icon
                        >{{ (type | formBuilderItemPipe).label }}</mat-option
                    >
                </mat-select>
            </mat-form-field>
        </div>

        <ng-container
            *ngIf="
                form.value.type == FieldType.SINGLE_CHOICE ||
                form.value.type == FieldType.MULTIPLE_CHOICE ||
                form.value.type == FieldType.DROPDOWN
            "
            formArrayName="options"
        >
            <div class="w-100 options-sep">Add related options</div>
            <div
                class="w-100"
                *ngFor="let option of optionsFormArray.controls; let i = index"
                fxLayout="column"
                fxLayoutAlign="center center"
                fxLayoutGap="1em"
            >
                <span class="item-title" i18n>Option {{ i + 1 }}</span>
                <div class="w-100" fxLayoutAlign="space-between center">
                    <app-title-translation
                        class="options-items"
                        type="title"
                        [borderedStyle]="true"
                        i18n-placeholder
                        placeholder="Option text"
                        [formControl]="option.get('value') | cast"
                    ></app-title-translation>
                    <ng-container *ngIf="!form.value.key">
                        <button
                            *ngIf="i == optionsFormArray.controls.length - 1"
                            mat-icon-button
                            (click)="addNewOption()"
                        >
                            <mat-icon>add_circle_outline</mat-icon>
                        </button>
                        <button
                            *ngIf="i != optionsFormArray.controls.length - 1"
                            mat-icon-button
                            (click)="removeOption(i)"
                        >
                            <mat-icon>delete</mat-icon>
                        </button>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="form.value.type && form.value.name">
            <div class="divider"></div>
            <div class="output w-100" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="start start">
                <div fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start start" class="output-label">
                    <mat-icon>preview</mat-icon>
                    <span i18n>Output (Default value)</span>
                </div>

                <ng-container [ngSwitch]="form.value.type">
                    <app-user-setting-input
                        *ngSwitchCase="FieldType.TEXT_INPUT"
                        type="text"
                        i18n-placeholder
                        [placeholder]="gettranslateValue(form.value.placeholder)"
                        [control]="form.get('initial_value') | cast"
                    >
                        <label role="input-label">{{ gettranslateValue(form.value.name) }}</label>
                    </app-user-setting-input>
                    <div
                        *ngSwitchCase="FieldType.DROPDOWN"
                        fxLayoutGap="4px"
                        fxLayout="column"
                        class="w-100 input-field-parent select"
                    >
                        <span>{{ gettranslateValue(form.value.name) }}</span>
                        <mat-form-field class="role-field">
                            <mat-label>{{ gettranslateValue(form.value.placeholder) }}</mat-label>

                            <mat-select fxFlex="1 1 100%" formControlName="initial_value">
                                <mat-option
                                    *ngFor="let option of optionsFormArray.controls"
                                    [value]="option.value.value"
                                    >{{ gettranslateValue(option.value.value) }}</mat-option
                                >
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <ng-container *ngSwitchCase="FieldType.DATE">
                        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent deadline">
                            <span i18n>{{ gettranslateValue(form.value.name) }}</span>
                            <mat-form-field
                                appearance="outline"
                                floatLabel="never"
                                class="w-100"
                                fxFlex="grow"
                                fxFlex="1 1 100%"
                                fxFlex.lt-md="1 1 100%"
                            >
                                <mat-label i18n>{{ gettranslateValue(form.value.placeholder) }}</mat-label>
                                <input
                                    matInput
                                    [matDatepicker]="deadlineDatepicker"
                                    (focus)="deadlineDatepicker.open()"
                                    formControlName="initial_value"
                                />
                                <mat-datepicker-toggle matIconSuffix [for]="deadlineDatepicker"></mat-datepicker-toggle>
                                <mat-datepicker #deadlineDatepicker></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </ng-container>
                    <app-user-setting-input
                        *ngSwitchCase="FieldType.SWITCH"
                        type="switch"
                        [control]="form.get('initial_value') | cast"
                    >
                        <span class="label" role="switch-label">
                            <ng-container>{{ gettranslateValue(form.value.name) }}</ng-container>
                        </span>
                    </app-user-setting-input>

                    <ng-container *ngSwitchCase="FieldType.SINGLE_CHOICE">
                        <div fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px">
                            <span>{{ gettranslateValue(form.value.name) }}</span>
                            <mat-radio-group
                                formControlName="initial_value"
                                class="course-sett-not"
                                fxLayout="column"
                                fxLayoutGap="10px"
                            >
                                <mat-radio-button
                                    *ngFor="let option of optionsFormArray.controls"
                                    [value]="option.value.value"
                                    >{{ gettranslateValue(option.value.value) }}</mat-radio-button
                                >
                            </mat-radio-group>
                        </div>
                    </ng-container>
                    <div
                        fxLayoutGap="10px"
                        fxLayout="column"
                        fxLayoutAlign="start start"
                        *ngSwitchCase="FieldType.MULTIPLE_CHOICE"
                        [formGroup]="checboxInitialValue"
                    >
                        <span>{{ gettranslateValue(form.value.name) }}</span>
                        <mat-checkbox
                            fxLayoutGap="10px"
                            fxLayout="column"
                            *ngFor="let option of optionsFormArray.controls; let i = index"
                            [formControlName]="option && option?.value?.id ? option.value.id : i"
                            (click)="$event.stopPropagation()"
                        >
                            {{ gettranslateValue(option.value.value) }}
                        </mat-checkbox>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <div class="action" fxLayout="row-reverse" fxLayoutAlign="start center" fxLayoutGap="10px">
        <button
            [disabled]="!form.valid"
            fxFlex="0 0 auto"
            class="mobile-button positive"
            (click)="onSubmit()"
            mat-raised-button
            data-testid="master-k3-field-submit"
        >
            <span i18n *ngIf="!navData?.data">Add field</span>
            <span i18n *ngIf="navData?.data">Edit field</span>
        </button>
        <button fxFlex="0 0 auto" class="mobile-button negative" (click)="onClose.emit()" mat-button i18n>
            Cancel
        </button>
    </div>
</div>
